import React from "react";
// import React, { useState } from "react";
import { Button } from "react-bootstrap";
// import { Button, Image } from "react-bootstrap";
// import getStage from "../../lib/getStage";
// import getDomain from "../../lib/getDomain";
// import isSiteBuilder from '../../lib/isSiteBuilder';

// function getLogo(){
//   if (isSiteBuilder()) return "https://assets.orenda.finance/members_orenda_finance/logo.jpg";
//   return `https://assets.orenda.finance/${getDomain()}/logo.jpg`;
// }

export default function TermsAndConditions({
  submitLegals,
  accountType,
  companyType,
  // legals = {},
}) {
  // const [termsRead, setTermsRead] = useState(true);
  // const [declarationRead, setDeclarationRead] = useState(true);

  return (
    <div className="terms-and-conditions">
{/*
      <Image
        className="logo"
        src={getLogo()}
        rounded
      />
*/}
      <div className="tscs-agree accepted">
        Fantastic news, you have been accepted!
      </div>

      <div
        className="tscs-agree business"
        // onClick={() => setTermsRead(true)}
      >
        <a
          href={"https://" + window.location.hostname + "/terms_and_conditions"}
          target="_blank"
          rel="noopener noreferrer"
        >
          Click here to read through our terms before accepting
        </a>
      </div>

      {companyType === "Sole Trader" && (
        <div
          className="tscs-agree sole-trader"
          // onClick={() => setDeclarationRead(true)}
        >
          <a
            href="https://docs.google.com/document/d/e/2PACX-1vTv51L49ALK6oR6xbpHuYJr3hGPpOzaLvF3u7wz0TC5RVfkFoU7_P8gGBucTAapQsOKrgMRr-2YpWei/pub"
            target="_blank"
            rel="noopener noreferrer"
          >
            Click here to read through the Sole Trader Declaration before
            accepting
          </a>
        </div>
      )}

      <Button
        variant="dark"
        block
        onClick={() => submitLegals()}
        // disabled={!(termsRead && declarationRead)}
      >
        {
          // termsRead && declarationRead ?
          "Click to accept"
          // : 
          // "Please click on the above links"
        }
      </Button>

      {
        // termsRead && declarationRead && (
          <div className="tscs-agree">
            By clicking, you agree that you have read and accept the Terms and
            Conditions
          </div>
        // )
      }
    </div>
  );
}
